import PropTypes from "prop-types";
import { FormGroup } from "@material-ui/core";
import { CheckBox } from "../CheckBox/CheckBox";

export const CheckBoxGroup = ({ fields, checkBoxData, onChange, disabled }) => {
  const fieldValues = fields.getAll() || [];

  return (
    <FormGroup>
      {checkBoxData.map(({ label, value }, index) => {
        const itemIndex = fieldValues.indexOf(value);
        return (
          <CheckBox
            key={label + index}
            label={label}
            name={label}
            disabled={disabled}
            onChange={(event) => {
              onChange && onChange(event);
              if (event.target.checked) {
                return fields.push(value);
              }

              fields.remove(itemIndex);
            }}
            input={{ value: itemIndex > -1 }}
          />
        );
      })}
    </FormGroup>
  );
};

CheckBoxGroup.propTypes = {
  fields: PropTypes.object,
  formatItem: PropTypes.func,
  onChange: PropTypes.func,
  checkBoxData: PropTypes.array,
};
